import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const RepeatSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default RepeatSVG;
